export const GETTERS = {};